import * as types from "./mutation-types";
import netwrok from "../utils/base/network";
import config from "../utils/config/config";
import api from "../utils/config/api";
import dynamicRouter from "../router/dynamic-router";
import store from "./index";
import router from "../router";

export default {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR");
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js